import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { FormMode, Languages, ServiceStatus, RefundApprovalDecision } from 'src/app/shared/models/enums.model';
import { ReleaseRefundRequestDTO, ReleaseRefundAdminDTO } from 'src/app/shared/models/long-haul.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { LongHaulService } from 'src/app/shared/services/long-haul.service';

@Component({
  selector: 'app-manager-approval',
  templateUrl: './manager-approval.component.html'
})
export class ManagerApprovalComponent {
  loading = false;
  showRequest: boolean = false;
  isErrorMessage: boolean = false;
  lockTaskErrorMessage: boolean = false;
  refundRequestObj: ReleaseRefundRequestDTO = new ReleaseRefundRequestDTO();
  refundAdminObj: ReleaseRefundAdminDTO = new ReleaseRefundAdminDTO();
  displayedLang: string;
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  baseRequestId: string = '';
  user: User = new User();
  refundManagerApprovalForm: FormGroup;
  responseObj: ResponseObject = new ResponseObject();
  requestStatus: number;
  @Input() public isShow: boolean = true;
  isLoaded: boolean = false;
  showRestudyDecision: boolean = false;



  constructor(
    private globalSrv: GlobalServices,
    private alertService: AlertService,
    private longhaulserv: LongHaulService) {
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getRequest();
    } else {
      window.history.back();
    }
    this.user = this.globalSrv.user;
  }

  getRequest() {
    this.longhaulserv.GetRefundRequestById(this.baseRequestId).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.refundRequestObj = this.responseObj.Data;
          this.requestStatus = this.refundRequestObj.BaseRequest.StatusId;
          this.isLoaded = true;
          if (this.refundRequestObj.ReleaseRestudyRequestId != null) {
            this.showRestudyDecision = true;
          }
          if (history.state.data && history.state.data.isCompleted) {
            this.formMode = FormMode.Readonly;
          }
          else if(this.requestStatus == ServiceStatus.Refund_PendingManagerApproval){
            this.formMode = FormMode.Add;
          }
          else{
            this.formMode = FormMode.Readonly;
          }
        }
      }
    )
  }

  onSubmit() {

    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    this.refundAdminObj.AdminEmail = this.user.UserName;
    this.refundAdminObj.Id = this.baseRequestId;
    this.refundAdminObj.ManagerSigned = RefundApprovalDecision.Approve;

    this.longhaulserv.SubmitManagerApprovalDecision(this.refundAdminObj)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            this.loading = false;
          }

        });
  }

}
